import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SessionProvider } from "./context/SessionContext";
import Layout from "./Layout";
import ArtistDashboard from "./pages/ArtistDashboard";
import ClassroomAdministrationInterface from "./pages/ClassroomAdministrationInterface";
import ClassrooomsAdminBrowser from "./pages/ClassroomsAdminBrowser";
import InstrumentalistInterface from "./pages/InstrumentalistInterface";
import InstrumentalistRegistrationModal from "./pages/InstrumentalistRegistration";
import ProjectSubmissionAdminInterface from "./pages/ProjectSubmissionAdminInterface";
import VideoBrowser from "./pages/VideoBrowser";
import VideoEditorInterface from "./pages/VideoEditorInterface";
import InstrumentalistsAdmin from "./pages/InstrumentalistAdminInterface";
import ActivityFeedPage from "./pages/ActivityFeedPage";
import UsersAdminBrowser from "./pages/UsersAdminBrowser";
import UserRegistrationModal from "./pages/UserRegistration";
import VideoEditorsAdmin from "./pages/VideoEditorAdminInterface";

const App: React.FC = () => (
	<BrowserRouter>
		<Routes>
			<Route path="/" element={<SessionProvider><Layout /></SessionProvider>}>
				<Route index element={<ActivityFeedPage />} />

				{/* Activity Feed routes (route-driven filter selection) */}
				<Route path="activity-feed" element={<ActivityFeedPage />} />
				<Route path="classroom/:classroomId/activity-feed" element={<ActivityFeedPage />} />
				<Route path="user/:userId/activity-feed" element={<ActivityFeedPage />} />

				<Route path="project-submissions-admin" element={<ProjectSubmissionAdminInterface />} />
				<Route path="instrumentalists-admin" element={<InstrumentalistsAdmin />} />
				<Route path="video-editors-admin" element={<VideoEditorsAdmin />} />
				<Route path="users-admin" element={<UsersAdminBrowser />} />
				<Route path="classrooms-admin" element={<ClassrooomsAdminBrowser />} />
				<Route path="instrumentalist" element={<InstrumentalistInterface />} />
				<Route path="video-editor" element={<VideoEditorInterface />} />
				<Route path="artist/:artistId" element={<ArtistDashboard />} />
				<Route path="videos" element={<VideoBrowser />} />
				<Route path="register" element={<UserRegistrationModal />} />
				<Route path="instrumentalist-registration" element={<InstrumentalistRegistrationModal />} />
				<Route path="classroom/:classroomId" element={<ClassroomAdministrationInterface />} />
				<Route path="*" element={<ActivityFeedPage />} />
			</Route>
		</Routes>
	</BrowserRouter>
);

export default App;
